import React, { useEffect, useState } from "react";
import { Grid, Typography, Button, TextField, CircularProgress, makeStyles, Paper } from "@material-ui/core";

import { useNavigate, Link } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Controller, useForm } from "react-hook-form";
import { useFetch } from "../../features/customHooks/useFetch";

const useStyles = makeStyles({
  container: { minHeight: "90vh", padding: 20 },
  usernameField: { marginTop: 20 },
  passwordField: { marginTop: 15 },
  buttonsContainer: { marginTop: 20, marginBottom: 10 },
  loginButton: {
    marginRight: 10,
    height: 50,
    flexGrow: 1,
  },
  registerButton: { height: 50 },
  paper: { padding: "10px 30px 10px 30px" },
  loginTypo: { fontSize: 35, fontWeight: 800, marginTop: 5 },
});

const Login = (props) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loginFetchState, setLoginFetchParams] = useFetch();

  const handleFormSubmit = (data) => {
    const params = {
      method: "post",
      url: "/login",
      data,
    };
    setLoginFetchParams(params);
  };

  useEffect(() => {
    if (localStorage.getItem("login")) navigate("/panel/valuations/new");
  }, []);

  useEffect(() => {
    if (!loginFetchState.loading && !loginFetchState.error && loginFetchState.data) {
      localStorage.setItem("login", loginFetchState.data.type + " " + loginFetchState.data.token);
      navigate("/panel/dashboard");
    }

    if (!loginFetchState.loading && loginFetchState.error) {
      if (loginFetchState?.data?.response?.status === 403)
        enqueueSnackbar("حساب کاربری شما تایید نشده!", {
          variant: "error",
        });

      if (loginFetchState?.data?.response?.status === 401)
        enqueueSnackbar("حساب کاربری با این مشخصات پیدا نشد!", {
          variant: "error",
        });
    }
  }, [loginFetchState]);

  return (
    <Grid container justifyContent='center' alignItems='center' className={classes.container}>
      <Grid item xs={12} sm={8} md={5} lg={4}>
        <Paper className={classes.paper}>
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <Typography className={classes.loginTypo}>ورود</Typography>

            <Controller
              name='username'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant='outlined'
                  label='نام کاربری'
                  fullWidth
                  error={errors.username}
                  helperText={errors.username && "فیلد نمیتواند خالی باشد"}
                  className={classes.usernameField}
                  disabled={loginFetchState.loading}
                />
              )}
            />

            <Controller
              name='password'
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  type='password'
                  variant='outlined'
                  label='رمز عبور'
                  fullWidth
                  error={errors.password}
                  helperText={errors.password && "فیلد نمیتواند خالی باشد"}
                  className={classes.passwordField}
                  disabled={loginFetchState.loading}
                />
              )}
            />

            <Grid container className={classes.buttonsContainer}>
              <Button
                color='primary'
                size='large'
                onClick={handleSubmit(handleFormSubmit)}
                variant='contained'
                disabled={loginFetchState.loading}
                type='submit'
                className={classes.loginButton}
              >
                {loginFetchState.loading ? <CircularProgress size={24} /> : "ورود"}
              </Button>

              <Button
                color='primary'
                size='large'
                variant='text'
                component={Link}
                to='/register'
                disabled={loginFetchState.loading}
                className={classes.registerButton}
              >
                ثبت نام
              </Button>
            </Grid>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Login;
